import { Control, useController } from "react-hook-form"
import { InputNumberFormat } from "@react-input/number-format"
import styles from "./styles.module.scss"
import { makeAutoObservable } from "mobx"
import { forwardRef, useMemo } from "react"
import { observer } from "mobx-react-lite"
import { DefaultInput } from "../DefaultInput"

type FormCurrencyInputProps = {
  name: string
  label: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any, any>
  parentBackgroundColor: string
  lightOutline?: boolean
  testId?: string
}

const CustomInput = forwardRef(
  (
    props: FormCurrencyInputProps & {
      value: string
      onChange: (value: string) => void
      onFocus: () => void
      onBlur: () => void
      isFocused: boolean
    },
    forwardedRef,
  ) => {
    const isFilled = props.value || props.isFocused
    return (
      <div className={styles.currencyInputContainer}>
        <span className={isFilled ? styles.currencySymbol : styles.currencySymbolHidden}>$</span>
        <DefaultInput
          {...props}
          className={isFilled ? styles.currencyInputFilled : ""}
          innerRef={forwardedRef}
        />
      </div>
    )
  },
)

class FormCurrencyInputState {
  isFocused: boolean

  constructor() {
    this.isFocused = false

    makeAutoObservable(this)
  }

  setIsFocused(value: boolean) {
    this.isFocused = value
  }
}

export const FormCurrencyInput = observer(function FormCurrencyInput({
  name,
  label,
  control,
  parentBackgroundColor,
  lightOutline = false,
  testId,
}: FormCurrencyInputProps) {
  const state = useMemo(() => new FormCurrencyInputState(), [])

  const {
    field: { onChange, value: textValue },
  } = useController({
    name,
    control,
    defaultValue: null,
  })

  const formattedLabel = textValue || state.isFocused ? label : `$  ${label}`

  return (
    <InputNumberFormat
      locales="en"
      minimumFractionDigits={2}
      maximumFractionDigits={2}
      currencyDisplay="symbol"
      component={CustomInput}
      name={name}
      control={control}
      parentBackgroundColor={parentBackgroundColor}
      lightOutline={lightOutline}
      testId={testId}
      value={textValue}
      onChange={onChange}
      label={formattedLabel}
      onFocus={() => state.setIsFocused(true)}
      onBlur={() => state.setIsFocused(false)}
      isFocused={state.isFocused}
    />
  )
})
